export function isAbortError(err: any) {
  return err && err.name === 'AbortError';
}

export const ErrorMessage = "An unexpected condition occurred, please contact your system administrator for more help";
